import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('issuer_period_audience', '/issuer_period_audiences')
const reducer = generator.generate()

export default reducer
